import {Hal} from './hal.model';

export class CaseRequestInformationHal extends Hal {
  teamId: string;
  caseId: string;
  caseName: string;
  clientUserId: string;

  constructor(data: any) {
    super(data);
    this.teamId = data.teamId;
    this.caseId = data.caseId;
    this.caseName = data.caseName;
    this.clientUserId = data.clientUserId;
  }
}
